export const itineraryRoutes = {
  view: [
    {
      path: 'ai-itinerary',
      children: [
        {
          path: '',
          title: `trip itinerary`,
          loadComponent: () =>
            import('./pages/view-ai-itinerary/view-ai-itinerary.page').then(
              (m) => m.ViewAiItineraryComponent,
            ),
        },
      ],
    },
  ],
};
